export default __webpack_public_path__ + "static/media/mau_card.901988b9.png";